import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { EventDispatcher } from '@opten/events/event-dispatcher';

export class PageRenderHelper {
	static onPageChange = new EventDispatcher<HTMLElement>();
	public static prevUrl: string;
	private headerCultures: HTMLElement;
	private readonly headerCulturesSelector = '.js-page-render-header-cultures';

	constructor(
		private innerContent: HTMLElement,
		private innerSelector: string
	) {
		this.headerCultures = document.querySelector(
			this.headerCulturesSelector
		);
		addClass(document.body, 'content-is-ready');
	}

	public fetch(url: string) {
		PageRenderHelper.prevUrl = PageRenderHelper.getFullUrl();
		return new Promise<{dom: Document, innerContent: HTMLElement}>((resolve, reject) => {
			if (
				this.innerContent.getAttribute('data-url') == url &&
				this.innerContent.innerHTML
			) {
				if (PageRenderHelper.getFullUrl() != url) {
					window.history.pushState(null, null, url);
				}
				return resolve(null);
			}
			removeClass(document.body, 'content-is-ready');
			this.innerContent.innerHTML = '';
			fetch(url)
				.then(response => response.text())
				.then(html => {
					const dom = new DOMParser().parseFromString(
						html,
						'text/html'
					);

					if (this.headerCultures) {
						const newHeaderCultures = dom.querySelector(
							this.headerCulturesSelector
						) as HTMLElement;
						this.headerCultures.innerHTML =
							newHeaderCultures.innerHTML;
					}

					const newContent = dom.querySelector(
						this.innerSelector
					) as HTMLElement;
					this.innerContent.setAttribute('data-url', url);
					this.innerContent.innerHTML = newContent.innerHTML;
					PageRenderHelper.onPageChange.dispatch(this.innerContent);

					window.history.pushState(null, null, url);
					window.document.title = dom.title;
					return resolve({ dom, innerContent: this.innerContent });
				})
				.catch(error => {
					// open error page
					window.location.href = url;
					return reject();
				})
				.finally(() => {
					addClass(document.body, 'content-is-ready');
				});
		});
	}

	public clear() {
		PageRenderHelper.prevUrl = undefined;
		this.innerContent.innerHTML = '';
	}

	public close(prevUrl?: string, prevTitle?: string) {
		if (prevUrl) {
			PageRenderHelper.prevUrl = prevUrl;
		}
		if (
			PageRenderHelper.prevUrl &&
			PageRenderHelper.prevUrl != PageRenderHelper.getFullUrl()
		) {
			window.history.pushState(null, null, PageRenderHelper.prevUrl);
			if (prevTitle) {
				document.title = prevTitle;
			}
			PageRenderHelper.prevUrl = undefined;
		}
	}

	public static getFullUrl() {
		return (
			window.location.pathname +
			window.location.hash +
			window.location.search
		);
	}
}
